module.exports = __webpack_public_path__ + "assets/benefits-shopping-cart-f84370.svg";